<template>
  <el-submenu v-if="menu.children && menu.children.length >= 1" :index="menu.path">
    <template slot="title">
      <font-icon :class="menu.icon" />
      <span slot="title">{{ menu.name }}</span>
    </template>
    <MenuTreeItem v-for="item in menu.children" :key="item.id" :menu="item"></MenuTreeItem>
  </el-submenu>
  <el-menu-item v-else :index="menu.path" @click="handleRoute(menu)">
    <font-icon :class="menu.icon" />
    <span slot="title">{{ menu.name }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'MenuTreeItem',
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleRoute(menu) {
      // 如果是嵌套页面，转换成iframe的path
      // 通过菜单URL跳转至指定路由
      this.$router.push(menu.path)
    }
  }
}
</script>

<style scoped lang="scss">
.el-menu .el-menu-item span,
.el-submenu .el-submenu__title span {
  margin-left: 10px;
}
.el-submenu .el-submenu__title span {
  margin-right: 15px;
}
// .el-submenu, .el-menu-item {
//   background-color: #3c4b5a44;
// }
</style>
